import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const getBookingPolicies = async (id) => {
  const response = await axiosInstance.get(API.BOOKING_POLICIES.GET_POLICIES + id);
  return response;
};
export const addBookingPolicies = async (body) => {
  const response = await axiosInstance.post(API.BOOKING_POLICIES.ADD_POLICIES, body);
  return response;
};
export const changeWindowSize = async (body) => {
  const response = await axiosInstance.post(API.BOOKING_POLICIES.ADD_WINDOW_SIZE, body);
  return response;
};
export const changePastWindowSize = async (body) => {
  const response = await axiosInstance.get(
    API.BOOKING_POLICIES.ADD_PAST_WINDOW_SIZE + body.locationId + '/' + body.scheduleWindowSize
  );
  return response;
};
export const updateEmailScheduling = async (body) => {
  const response = await axiosInstance.post(API.BOOKING_POLICIES.ADD_EMAIL_SCHEDULER, body);
  return response;
};

export const updateDoubleBookingSettings = async ({
  locationId,
  isDoubleBookingAllowed,
  maxDoubleBookings
}) => {
  const response = await axiosInstance.post(
    `${API.BOOKING_POLICIES.DOUBLE_BOOKINGS}?locationId=${parseInt(locationId)}&isDoubleBookingAllowed=${isDoubleBookingAllowed}&maxDoubleBookings=${maxDoubleBookings}`
  );

  return response;
};

/**
 * Saves the location's booking-flow flags (Appointment Journey tab). The
 * backend rejects (400) any combination other than exactly one of
 * serviceOnly / professionalFirst / profAndSerNoAssociation, with
 * areProfessionalsEnabled on only for the last two.
 * @param {{ locationId: number, serviceOnly: boolean, isCategoryEnabled: boolean,
 *   areProfessionalsEnabled: boolean, professionalFirst: boolean, profAndSerNoAssociation: boolean }} payload
 */
export const updateAppointmentJourney = async (payload) => {
  const response = await axiosInstance.post(API.BOOKING_POLICIES.APPOINTMENT_JOURNEY, {
    ...payload,
    locationId: parseInt(payload.locationId)
  });
  return response;
};

export const updateTimeFormat = async ({ locationId, timeFormat }) => {
  const response = await axiosInstance.post(
    `${API.BOOKING_POLICIES.TIME_FORMAT}?locationId=${parseInt(locationId)}&timeFormat=${timeFormat}`
  );

  return response;
};

export const updateEmailSenderName = async ({ locationId, emailSenderName }) => {
  const response = await axiosInstance.get(
    `${API.BOOKING_POLICIES.EMAIL_SENDER_NAME}${parseInt(locationId)}/${emailSenderName}`
  );

  return response;
};
